<template>
  <el-dialog title="拉黑配置" :visible.sync="dialogFormVisible"  append-to-body  @close="closeDialog" :close-on-click-modal="false">
    <el-form :model="form" label-width="80px" :rules="rules" ref="formModel">
      <el-form-item label="是否拉黑" prop="enabled">
          <el-radio v-model="form.enabled" :label="false">是</el-radio>
          <el-radio v-model="form.enabled" :label="true">否</el-radio>
      </el-form-item>
      <el-form-item label="拉黑选项" prop="type" v-if="!form.enabled">
        <el-radio-group v-model="form.type">
          <el-radio v-for="(item,index) in typeList" :label="item.value" :key="index">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="时间段" v-if="form.type==1 && !form.enabled">
        <div v-for="(item,index) in form.timeRanges" :key="index" style="display:flex;margin-bottom:10px;align-items:center;">
          <el-date-picker
              v-model="form.timeRanges[index]"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              @change="onTimeRangeChange(index)"
          >
          </el-date-picker>
          <el-button type="danger" icon="el-icon-delete" circle @click="removeTimeRange(index)" v-if="form.timeRanges.length > 1" style="margin-left:10px;"></el-button>
        </div>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="addTimeRange">添加时间段</el-button>
      </el-form-item>
      <el-form-item label="出库批次" v-if="form.type==2 && !form.enabled" prop="lotNumbers">
        <el-select v-model="form.lotNumbers" filterable multiple  placeholder="请选择" style="width:100%;">
          <el-option
              v-for="opt in lotNumberList"
              :key="opt.id"
              :label="opt.lotNumber"
              :value="opt.lotNumber">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="save" :loading="saveLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  fetchDealerBlockList,fetchAddDealerBlock,fetchDealerLotNumber
} from '@/api/dealerBlockLog.js'

export default {
  name: "dealerBlockLog",
  components: {

  },
  data() {
    return {
      dialogFormVisible:false,
      serchParams: {
        dealerId: '',
      },
      typeList:[
        {value: 0, label: '全部'},
        {value: 1, label: '出库时间区间'},
        {value: 2, label: '出库批次'},
      ],
      lotNumberList:[],
      saveLoading:false,
      pickerOptions:{
        disabledDate(time){
          return time.getTime() > Date.now()
        }
      },
      pageNum: 1,
      pageSize: 10,
      form:{
        id:'',
        type:0,
        dealerId:'',
        lotNumbers:[],
        timeRanges:[[]],
        enabled:false
      },
      rules: {
        enabled: [
          { required: true, message: '请选择是否拉黑', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' },
        ],
      }
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    getLotNumber(){
      fetchDealerLotNumber(this.serchParams).then(res=>{
        this.lotNumberList = res.data
      })
    },
    openDialog(row){
      this.serchParams.dealerId = row.id
      this.form.dealerId = row.id
      this.form.enabled = row.enabled
      this.getLotNumber()
      this.getList()
      this.dialogFormVisible = true
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    save(){
      this.saveLoading = true
      if (this.form.type == 1){
        let valid = this.form.timeRanges.every(item => item && item.length == 2)
        if (!valid){
          this.$message.warning("请选择完整的时间段")
          this.saveLoading = false
          return
        }
        this.form.times = this.form.timeRanges.map(item => ({startTime: item[0], endTime: item[1]}))
      }
      if (this.form.type == 2){
        if (!this.form.lotNumbers || this.form.lotNumbers.length == 0){
          this.$message.warning("请选择出库批次")
          this.saveLoading = false
          return
        }
      }
      fetchAddDealerBlock(this.form).then(res=>{
        this.$message.success("操作成功")
        this.dialogFormVisible = false
      }).catch(()=>{
        this.$message.error("操作失败")
      }).finally(()=>{
        this.saveLoading = false
      })
    },
    closeDialog(){
      this.$emit('getList')
    },
    addTimeRange(){
      this.form.timeRanges.push([])
    },
    removeTimeRange(index){
      this.form.timeRanges.splice(index, 1)
    },
    onTimeRangeChange(index){
      let current = this.form.timeRanges[index]
      if (!current || current.length != 2) return
      let duplicate = this.form.timeRanges.some((item, i) => {
        if (i === index) return false
        if (!item || item.length != 2) return false
        return item[0] === current[0] && item[1] === current[1]
      })
      if (duplicate){
        this.$message.warning("该时间段已存在，请勿重复选择")
        this.$set(this.form.timeRanges, index, [])
        return
      }
      let overlap = this.form.timeRanges.some((item, i) => {
        if (i === index) return false
        if (!item || item.length != 2) return false
        return current[0] < item[1] && item[0] < current[1]
      })
      if (overlap){
        this.$message.warning("该时间段与已有时间段存在交叉，请重新选择")
        this.$set(this.form.timeRanges, index, [])
      }
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    resetSearch() {
      this.serchParams.dealerId = ''
      this.pageNum = 1
      this.getList()
    },
    getList() {
      let params = {
        dealerId: this.serchParams.dealerId,
      }
      fetchDealerBlockList(params).then(res => {
        let data = res.data
        this.form.type = data.blockType
        this.form.enabled = data.enabled
        if (data.blockType == 0){
          this.form.timeRanges = [[]]
          this.form.lotNumbers = []
          this.form.id = ''
        } else if (data.blockType == 1){
          let list = data.list || []
          if (list.length > 0){
            this.form.id = list[0].id
            this.form.timeRanges = list.map(item => [item.startTime, item.endTime])
          } else {
            this.form.id = ''
            this.form.timeRanges = [[]]
          }
          this.form.lotNumbers = []
        } else if (data.blockType == 2){
          let list = data.list || []
          if (list.length > 0){
            this.form.id = list[0].id
            this.form.lotNumbers = list.map(item => item.lotNumber)
          } else {
            this.form.id = ''
            this.form.lotNumbers = []
          }
          this.form.timeRanges = [[]]
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.name_status {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(63, 114, 246, 0.11);
  border: 1px solid #3F72F6;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3F72F6;
  text-align: center;
}

.name_status1 {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(243, 136, 46, 0.11);
  border: 1px solid #F3882E;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F3882E;
  text-align: center;
}

.copyTxt {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  color: #3F72F6;
}

.greenTag {
  color: #fff;
  background: #08A89B;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.greyTag {
  background: #e5e5e5;
  color: #333;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.redTag {
  background: #e5e5e5;
  color: #f00;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;
}

.redBtn, .redColor {
  color: #f00;
}
</style>
